<template>
  <div>
    <pre>{{ user }}</pre>
    <pre>{{ roles }}</pre>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'

const store = useStore()

const roles = computed(() => store.state.roles)
const user = computed(() => store.state.user)
</script>

<style lang="scss" scoped>

</style>
